import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { AccountFacade } from 'ish-core/facades/account.facade';
import { MfaVerificationFormComponent } from 'ish-shared/components/login/mfa-verification-form/mfa-verification-form.component';

/**
 * Presidio — MFA verify as NgbModal overlay on Sign-in.
 */
@Component({
  selector: 'ish-mfa-verification-modal',
  templateUrl: './mfa-verification-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, MfaVerificationFormComponent],
})
export class MfaVerificationModalComponent implements OnInit, OnDestroy {
  private activeModal = inject(NgbActiveModal);
  private accountFacade = inject(AccountFacade);
  private readonly destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.accountFacade.isLoggedIn$.pipe(filter(Boolean), takeUntil(this.destroy$)).subscribe(() => this.hide());

    this.accountFacade.mfaChallenge$
      .pipe(
        filter(challenge => !challenge),
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.hide(false));
  }

  hide(clearChallenge = true): void {
    if (clearChallenge) {
      this.accountFacade.clearMfaChallenge();
    }
    this.activeModal.dismiss();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
